import Navbar from "@/components/Mobile/Navbar.vue";
import File from "@/views/private/File.vue";
import Test from "@/views/Test.vue";
import InformationsPersonnelles from "@/views/private/formulaire/InformationsPersonnelles.vue";
import ParcoursProfessionnel from "@/views/private/formulaire/ParcoursProfessionnel.vue";
import EnregistrementDossier from "@/views/private/formulaire/EnregistrementDossier.vue";
import RouteEnum from "@/router/RouteEnum";

export default [
    {
        path: "/dossier",
        name: RouteEnum.CANDIDACY_FILE,
        components: {
            default: File,
            footer: Navbar
        },
    },
    {
        path: "/dossier",
        children: [
            {
                path: "mes-tests",
                name: RouteEnum.CANDIDACY_TESTS,
                components: {
                    default: Test,
                    footer: Navbar
                },
            },
            {
                path: "candidature/informations_personnelles",
                name: RouteEnum.CANDIDACY_INFO_PERSONAL,
                components: {
                    default: InformationsPersonnelles,
                    footer: Navbar
                },
            },
            {
                path: "candidature/parcours_professionnel",
                name: RouteEnum.CANDIDACY_INFO_PROFESSIONAL,
                components: {
                    default: ParcoursProfessionnel,
                    footer: Navbar
                },
            },
            {
                path: "candidature/enregistrement_dossier",
                name: RouteEnum.CANDIDACY_REGISTRATION,
                components: {
                    default: EnregistrementDossier,
                    footer: Navbar
                },
            }
        ]
    },
]
